import { createStore } from 'vuex'
import theme from './modules/theme'
import language from './modules/language'
import shop from './modules/shop'

export default createStore({
    modules: {
        theme,
        language,
        shop
    }
})
